/**
 *  InputFile script file
**/

export default {
  name: 'InputFile',
  mixins: [],
  components: {},
  props: {
    // NOTE: needed if has multiple inputs
    id: {
      type: [Number, String],
      required: false
    },
    label: {
      type: String,
      default: 'Select',
      required: false
    },
    noFileText: {
      type: String,
      default: 'No file selected',
      required: false
    },
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#Unique_file_type_specifiers
    fileTypes: {
      type: Array,
      default: () => ['image/*', 'video/*'],
      required: false
    },
    multiple: {
      type: Boolean,
      default: false,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      files: [],
      uploading: false
    }
  },
  computed: {
    getTypes () {
      return this.fileTypes.join()
    }
  },
  methods: {
    previewFiles () {
      this.files = this.$refs.input.files
      this.$emit('preview', this.multiple ? this.files : this.files[0])
    },
    upload () {
      this.$emit('uploaded', this.multiple ? this.files : this.files[0])
      this.files = []
    },
    clear () {
      this.$refs.input.value = ''
    }
  }
}
